export default __webpack_public_path__ + "static/N0090-03898be5817a47e0f7e67f7701349ee6.png";